import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Obs = {
  healthzUrl: string;
  readyzUrl: string;
  metricsUrl: string;
  buildInfo: string;
};

export default function PlatformObservabilityPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<Obs>("/api/v1/tenant/platform/observability");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("platform.observability.title")}</h1>
      <p className="mt-2 text-slate-500">{t("platform.observability.note")}</p>
      {loading && <p className="mt-4 text-slate-500">{t("common.loading")}</p>}
      {error && <p className="mt-4 text-red-600">{error}</p>}
      {data && (
        <ul className="mt-6 space-y-2 text-sm">
          {[
            ["healthz", data.healthzUrl],
            ["readyz", data.readyzUrl],
            ["metrics", data.metricsUrl],
            ["build", data.buildInfo],
          ].map(([label, href]) => (
            <li key={label}>
              <a href={href} className="text-brand-700 hover:underline" target="_blank" rel="noreferrer">
                {label}: {href}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
